import { mapJobSiteV2DTOToFormData } from '../mappers/JobSiteMappers';
import { useGetJobSiteQuery } from '@/common/infrastructure/gql/generated/schema';
import { useMemo } from 'react';

/**
 * Hook to get job site using V2 DTO types
 * Uses the proper Dtos_V2_JobSite_JobSiteDto type from GraphQL schema
 */
export const useGetJobSiteV2DTO = (jobSiteId?: number, skipQuery?: boolean) => {
  const skip = skipQuery || !jobSiteId || isNaN(jobSiteId);

  const { data, loading, error } = useGetJobSiteQuery({
    variables: { jobSiteId: jobSiteId! },
    skip
  });

  const jobSite = data?.jobsiteDetails ?? null;

  const formData = useMemo(() => mapJobSiteV2DTOToFormData(jobSite as Parameters<typeof mapJobSiteV2DTOToFormData>[0]), [jobSite]);

  const availableJobSiteTypes = useMemo(() => jobSite?.availableJobSiteTypes ?? [], [jobSite]);

  return {
    jobSite: formData,
    rawJobSite: jobSite,
    loading,
    error,
    deletable: jobSite?.deletable ?? false,
    availableJobSiteTypes
  };
};
